module.exports = __webpack_public_path__ + "img/thumb-taylor-off.5f1c044c.jpg";